type Row = { label: string; value: string | number };

type Props = { rows: Row[] };

export default function SiteMetricTable({ rows }: Props) {
  return (
    <div className="overflow-hidden rounded-[8px] border border-[#F0F2F4] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.08)]">
      <table className="w-full text-[13px]">
        <thead>
          <tr className="border-b border-[#F0F2F4] bg-[#FAFBFC]">
            <th className="text-left px-4 py-2 font-semibold text-[#2B4752] w-1/2">
              Metric
            </th>
            <th className="text-left px-4 py-2 font-semibold text-[#2B4752] w-1/2">
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr
              key={i}
              className="border-b border-[#F0F2F4] last:border-0 hover:bg-[#FAFBFC]"
            >
              <td className="px-4 py-2 text-[#595959]">{row.label}</td>
              <td className="px-4 py-2 text-[#2B4752] font-medium">
                {row.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
